import { Button, Checkbox, Col, Form, message, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import InputBox from "../../../../components/common/input";
import DropdownSelect from "../../../../components/common/select";
import FileUploadFun from "../../../../components/common/fileUploadFun/FileUploadFun";
import { uploadFile } from "../../../../redux/reducer/UploadSlice";
import { addHomeCategory, updateHomeCategory, viewHomeCategory } from "../../../../redux/reducer/homeCategorySlice";
import { useDispatch, useSelector } from "react-redux";
import { urlConstant } from "../../../../constants/urlConstant";
import { useLocale } from "antd/es/locale";
import { listSubscriptionFun } from "../../../../redux/reducer/SubscriptionSlice";
import { toast } from "react-toastify";

const options = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];

const AddHomeCategory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [uploadedFile, setUploadedFile] = useState(null);
  const dispatch = useDispatch()
  const location = useLocation()
  const { fileUrl } = useSelector((state) => state.upload);
  const {addCategoryLoading, updateCategoryLoading, viewCategory } = useSelector(prev => prev?.homeCategory)

 

  const editData = location.state?.editData || null;

  // viewHomeCategory

  const { listSubscription } = useSelector((state) => state.subscription);

  useEffect(() => {
    dispatch(listSubscriptionFun());
  }, [dispatch]);

  const listSubscriptionData = listSubscription.map(({ id, name_en }) => ({
    label: name_en,
    value: id,
  }));



  useEffect(() => {
    if (editData) {
      dispatch(viewHomeCategory(editData?.id));
    }
  }, [dispatch, editData]);

  useEffect(() => {
    if (viewCategory && editData) {
      form.setFieldsValue({
        name_en: viewCategory.name_en,
        name_es: viewCategory.name_es,
        name_pt: viewCategory.name_pt,
        sequence: viewCategory?.sequence,
        subscription_ids: viewCategory?.subscription_ids || [],
        // icon: viewCategory.image_url || "https:www.pexels.com",
      });
    } else {
      form.resetFields(); // Ensure blank form on add
    }
  }, [editData, viewCategory, form]);



 
 
  const handleFileUpload = async (file) => {
    const data = await dispatch(uploadFile(file));
    setUploadedFile(file);
  };

  useEffect(() => {
    if (fileUrl) {
      form.setFieldsValue({ image_url: fileUrl.rows[0]?.image_url });
    }
   
  }, [fileUrl, form]);
  // extra
  // const {viewCategory} = useSelector((prev) => prev?.celebrityCategory)



  const onFinish = async (values) => {
    const formData = {
      name_en: values.name_en,
      name_es: values.name_es,
      name_pt: values.name_pt,
      sequence: values.sequence,
      subscription_ids: values.subscription_ids, // ✅ add this
      // icon: values.image_url || "https:www.pexels.com",
    };

    try {
      let response;
      if (editData) {
        // Update existing category
        response = await dispatch(updateHomeCategory({ id: editData.id, data: formData })); 
        if(response.type === "homeCategory/update/fulfilled"){
          toast.success("Home category updated successfully")
          navigate(-1)
         }
      } else {
        // Add new category
        response = await dispatch(addHomeCategory(formData));
        if(response.payload.code === 201){
          toast.success(response?.payload?.message)
          navigate('/manage-home-category')
        }
        else{
          toast.error(response?.payload?.message)
        }
      }

      if (response?.payload?.code === 201 || response?.type === "homeCategory/update/fulfilled") {
        navigate(urlConstant?.manageHomeCategoryRoute);
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };
  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">{editData ? "Edit" : "Add"} Home Category Details</div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" loading={editData ? updateCategoryLoading : addCategoryLoading} onClick={() => form.submit()}>{editData ? "Update Details" : "Save Details"}</Button>
        </Space>
      </div>

      <Form 
        form={form} 
        layout="vertical" 
        onFinish={onFinish}
      >
        <Row gutter={16}>
          {/* English Category Name */}
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_en"
              label="Category Name (en)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" className="custom-input" />
            </Form.Item>
          </Col>

          {/* Spanish Category Name */}
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_es"
              label="Category Name (es)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" className="custom-input" />
            </Form.Item>
          </Col>

          {/* Portuguese Category Name */}
          <Col xs={24} sm={8}>
            <Form.Item
              name="name_pt"
              label="Category Name (pt)"
              rules={[
                { required: true, message: "Please enter category name" },
              ]}
            >
              <InputBox size="large" placeholder="Enter category name" className="custom-input" />
            </Form.Item>
          </Col>

          {/* Dropdown Select */}
          {/* File Upload */}
          <Col xs={24} sm={8}>
            <Form.Item
              name="sequence"
              label="Enter sequence"
              rules={[
                { required: true, message: "Please enter sequence" },
                {
                  pattern: /^[1-9][0-9]*$/,
                  message: "Only positive integers are allowed",
                },
              ]}

            >
              <InputBox size="large" placeholder="Enter sequence" className="custom-input" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              name="subscription_ids"
              label="Add To Plan"
              rules={[{ required: true, message: "Select a subscription" }]}
            >
              <DropdownSelect
                options={listSubscriptionData}
                placeholder="Choose..."
                mode="multiple"
                value={form.getFieldValue("subscription_ids")}
                onChange={(value) =>
                  form.setFieldsValue({ subscription_ids: value })
                }
              />
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </div>
  );
};

export default AddHomeCategory;

